const DepositAmount = ({
  value,
  onValueChange,
  totalAmount,
  setAmountToSend
}) => {
  const handleSetInput = e => {
    let pad = e.target.value;

    // Allow only numbers and a dot with restrictions
    if (/^(0|[1-9][0-9]*)(\.[0-9]*)?$/.test(pad) || pad === '') {
      onValueChange(pad);
    }
  };
  function centerAmount(calculatedAmount) {
    const length = calculatedAmount?.toString().length || 0;
    if (length === 2) {
      return 'text-[78px] -translate-x-[40px]';
    }
    if (length >= 8) {
      return 'text-[42px] -translate-x-[-70px]';
    }
    if (length >= 7) {
      return 'text-[52px] -translate-x-[-50px]';
    }
    if (length >= 5) {
      return 'text-[52px] -translate-x-[-20px]';
    }
    if (length >= 4) {
      return 'text-[52px] -translate-x-[0px]';
    }
    if (length >= 3) {
      return 'text-[52px] -translate-x-[10px]';
    }
    return 'text-[78px] -translate-x-[50px]'; // Default for no value or single-digit input
  }
  return <>
            <div className='flex flex-col justify-center items-center my-12 w-full'>
                <div className="w-full h-[80px] relative">
                    <div className='text-genius-cream break-all w-full'>
                        <div className="w-full">
                            <div className={`w-full justify-center items-center transition-all`}>
                                <div className={`flex justify-center w-full items-center 
                                                    absolute top-1/2 transform -translate-y-1/2
                                                     ${centerAmount(Number(totalAmount))}`}>
                                    <input type="text" value={totalAmount} onChange={handleSetInput} className={`p-0 m-[0px] ta-r w-[50%] bg-transparent border-none focus:outline-none focus-visible:outline-none text-genius-cream`} placeholder="0" />
                                    <span className="text-genius-cream/70 w-[50%]">USD</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex items-center justify-center space-x-4'>
                <div onClick={() => setAmountToSend('50')} className='bg-genius-blue cursor-pointer rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
                    <p className='m-auto'>$50</p>
                </div>
                <div onClick={() => setAmountToSend('100')} className='bg-genius-blue cursor-pointer rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
                    <p className='m-auto'>$100</p>
                </div>
                <div onClick={() => setAmountToSend('500')} className='bg-genius-blue cursor-pointer rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
                    <p className='m-auto'>$500</p>
                </div>
                <div onClick={() => setAmountToSend('1000')} className='bg-genius-blue cursor-pointer rounded-full ta-c h-[31px] w-[61px] text-[14px] text-genius-cream flex items-center'>
                    <p className='m-auto'>$1000</p>
                </div>
            </div>
        </>;
};
export default DepositAmount;